module.exports = __webpack_public_path__ + "static/media/han_con_saw.6357cc12.png";